import React from "react";
import ReactDOM from "react-dom";
import BarChart from './BarChart';
import LoaderMask from '../../components/common/LoaderMask';
import LoggedInPage from '../../views/core/LoggedInPage';


export default class Barchart_Overall extends LoggedInPage{

    constructor(props){
        super(props)
    }
    
    getColor(percentage){
      var percArr= window.barchartColor || ['#9c9e9f','#F73E21','#fb9100','#7cb045'];
        var clrval = percArr[1];
        if(percentage>=41 && percentage <=70){
            clrval = percArr[2];
        }else if(percentage>70 && percentage <=100){
            clrval = percArr[3];  
        }
          return clrval;
    }


  render() {
    var rclrVal= '#D3D3D3';
    var data = [];
    if(this.props.benchMarkData && this.props.benchMarkData!=null){
      var percentile = this.props.benchMarkData.percentile;
      var getperc = Math.abs(percentile.percentile_ranking);
      var overallscore = 100;
      var loseperc = overallscore-getperc;

      //data = ["tooltip title","percentage","leftbarcolor","Bar inside txt","100-perce","rightbarcolor"];

      data = [
        ['', '',{ role: 'style' },{
            sourceColumn: 0,
            role: 'annotation',
            type: 'string',
            calc: 'stringify',
          }, '',{ role: 'style' }],
          ['', getperc, this.getColor(getperc),String(getperc),loseperc,rclrVal]
    ];
    }


  
  const params = {
      chartType:"BarChart",
      width:'auto',
      height:'200px',
      loader:LoaderMask,
      data:data,
      options:{
          title: '',
          chartArea: { width: '70%' },
          legend: { position: 'none' },
          isStacked: true,
          bar: { groupWidth: '50%' },
          legend: { position: 'none' },
          hAxis: {
              title: 'Percentile Ranking',
              minValue: 0,
              italic:false,
              baseline:(getperc),
              baselineColor:'#003465',
              textStyle:{
                color:'#003465',
                fontSize:14
              },
              gridlines:{
                color:'#fff'
              }
          }
      }
  }
    return (
      <BarChart params={params}/>
    );
  }
}


// WEBPACK FOOTER //
// ./src/vendors/prep/Barchart_Overall.js